module.exports = __webpack_public_path__ + "static/media/World.3b027b8c.svg";